import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import ReservationDetailView from './ReservationDetailView';
import { Creators as cancelReservationAction } from '../../../../../domain/useCases/reservation/cancelReservationUseCase';
import { Creators as getDetailAction } from '../../../../../domain/useCases/reservation/getReservationDetailUseCase';
import XCheckpointManager from '../../../../../core/managers/xcheckpointManager';
import useLocationQuery from '@/presentation/hooks/useQuery';
import { useRole } from '@/presentation/hooks/useRole';

const ReservationDetailViewController = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { isVisor } = useRole();
  const [restriction, setRestriction] = useState(false);
  const idReservation = useLocationQuery('id');
  const goBackButton = () => {
    history.push('/servicios/recursos');
  };

  const cancelReservation = (id: number) => {
    if (isVisor) {
      setRestriction(true);
      return;
    }
    dispatch(cancelReservationAction.cancelReservation(id));
  };

  const { isLoading, data } = useSelector(
    (state: any) => state.getReservationDetail
  );
  const { isLoading: isLoadingCancel, isSuccess: isSuccessCancel } =
    useSelector((state: any) => state.cancelReservation);

  useEffect(() => {
    XCheckpointManager.registerStart('Reserva recursos detalle');
    dispatch(getDetailAction.getReservationDetail(idReservation));
    return () => {
      if (isVisor) {
        setRestriction(true);
        return;
      }
      dispatch(getDetailAction.getReservationDetailClear());
      dispatch(cancelReservationAction.cancelReservationClear());
    };
  }, []);

  useEffect(() => {
    if (data) {
      XCheckpointManager.registerEnd('Reserva recursos detalle');
    }
  }, [data]);

  useEffect(() => {
    if (isSuccessCancel) history.push('/servicios/recursos');
  }, [isSuccessCancel]);

  return (
    <ReservationDetailView
      isLoading={isLoading}
      goBackButton={goBackButton}
      reservationDetail={data?.reservationDetail}
      isProcessing={isLoadingCancel}
      onCancelReservation={cancelReservation}
      restriction={restriction}
      setRestriction={setRestriction}
    />
  );
};

export default ReservationDetailViewController;
